import { render, staticRenderFns } from "./list-view.vue?vue&type=template&id=706cc405&scoped=true"
import script from "./list-view.vue?vue&type=script&lang=js"
export * from "./list-view.vue?vue&type=script&lang=js"
import style0 from "./list-view.vue?vue&type=style&index=0&id=706cc405&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706cc405",
  null
  
)

export default component.exports